import { ClerkProvider } from '@clerk/clerk-react';
import { ReactNode } from 'react';

const CLERK_PUBLISHABLE_KEY = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;

interface ClerkWrapperProps {
  children: ReactNode;
}

export function ClerkWrapper({ children }: ClerkWrapperProps) {
  if (!CLERK_PUBLISHABLE_KEY) {
    throw new Error(
      'Missing Clerk Publishable Key. Add VITE_CLERK_PUBLISHABLE_KEY to your .env file.'
    );
  }

  return (
    <ClerkProvider publishableKey={CLERK_PUBLISHABLE_KEY}>
      {children}
    </ClerkProvider>
  );
}
